import { Container } from 'react-bootstrap';
import styled from 'styled-components';
import { calcResize, SpacedTitle } from 'components/Layout/styles';
import { mediaBreakpointDown } from 'utils/styledCssHelpers';
import GracefulImage from 'components/GracefulImage';
/* 
calc( 48px + (68 - 48) * (100vw - 320px) / (1024 - 400) );

48 - Min size
68 - Max size

320 - min screen size
1024 - max screen size

*/
export const SSection = styled.section`
  /* padding-top: ${calcResize(50, 200)}; */
  display: flex;
  align-items: center;
  min-height: ${props => (props.type === 'small' ? '50vh' : '100vh')};
  top: ${props => (props.type === 'small' ? '50px' : null)};
  position: relative;

  color: ${props =>
    props.$backgroundColor === 'primary' ? '#ffffff' : props.theme.colors.main};

  &::before,
  &::after {
    content: '';
    width: 100%;
    position: absolute;
    left: 0;
    top: 0vh;
    height: 100%;
    z-index: 0;
  }

  &::before {
    background: url(${props => props.backgroundImage});
    background-position: center;
    background-size: cover;
  }

  &::after {
    background: rgba(0, 0, 0, 0.2);
  }
`;

export const SActions = styled.div`
  margin-top: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  ${mediaBreakpointDown(
    'md',
    `
    flex-direction: column;
  `,
  )}
`;

export const STitle = styled.h1.attrs(() => ({
  className: 'text-center',
}))`
  display: block;
  font-weight: bold;
  font-size: ${calcResize(40, 70)};
  color: #ffffff;
  letter-spacing: -0.05em;
  margin-top: 10px;
  font-weight: bold;

  & .highlight {
    color: ${props =>
      props.highLightMode === 'dark'
        ? props.theme.colors.main
        : props.theme.colors.light_blue};
    font-size: inherit;
  }
`;

export const SSlug = styled(SpacedTitle)`
  text-align: center;
  letter-spacing: 4px;
`;

export const SSubTitle = styled.h2.attrs(() => ({
  className: 'text-center',
}))`
  max-width: 800px;
  margin: 30px auto 0 auto;
  font-weight: normal;

  font-size: ${calcResize(14, 20)};
  color: #ffffff;
  letter-spacing: 0em;

  a {
    color: ${props =>
      props.highLightMode === 'dark'
        ? props.theme.colors.main
        : props.theme.colors.light_blue};
  }
`;
export const SContainer = styled(Container)`
  z-index: 1;
`;

export const SImage = styled(GracefulImage)`
  position: absolute !important;
  width: 100%;
  height: 100%;
  top: 0px;
  left: 0px;
`;
